/**
 * @author TomaszCzura ({}
 */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import LogsKeyCreationList from './LogsKeyCreationList';
import WhitePortlet from '../../utils/WhitePortlet';
import RoleBasedComponent from '../../utils/RoleBasedComponent';
import * as blockUtils from './../../../utils/BlockUtils';
import i18next from 'i18next';
import ErrorBox from './../../utils/ErrorBox';
import {getErrorDescription} from '../../../utils/view-utils';
import * as rights from '../../../model/rights';
import * as logsApi from '../../../api/log-api';

class LogsKeyCreationListContainer extends RoleBasedComponent {
  constructor(props) {
    super(props);

    this.tableId = 'logs_key_creation_table';

    this.getData = this.getData.bind(this);

    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'id';
    this.sortingType = 'asc';
    this.searchPhrase = '';
  }

  componentDidMount() {
    const data = {
      pageNumber: this.pageNumber,
      size: this.elementsCount,
      query: this.searchPhrase,
      sort: `${this.sortingName},${this.sortingType.toLowerCase()}`,
    };

    this.checkRights(() => logsApi.getLogsForKeyCreation(data));
  }

  getRights() {
    return rights.LOG_READ_PRIVILEGE;
  }

  getData(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };
    blockUtils.blockUI();
    logsApi.getLogsForKeyCreation(data);

    this.pageNumber = pageNumber;
    this.elementsCount = elementsCount;
    this.sortingName = sortingName;
    this.sortingType = sortingType;
    this.searchPhrase = searchPhrase;
  }

  render() {
    return (
      <WhitePortlet caption={i18next.t('logs.key_creation.title')} icon="icon-screen-smartphone">
        <ErrorBox errorMessage={getErrorDescription(this.props.getLogsError)}/>

        <LogsKeyCreationList
          logs={this.props.logs}
          getData={this.getData}
          tableId={this.tableId}
          defaultSort={[0, 'asc']}
          totalPages={this.props.totalPages}
          totalElements={this.props.totalElements}
        />
      </WhitePortlet>
    );
  }
}

LogsKeyCreationListContainer.propTypes = {
  logs: PropTypes.array,
  getLogsError: PropTypes.object,
  totalElements: PropTypes.number,
  totalPages: PropTypes.number,
};

LogsKeyCreationListContainer.defaultProps = {};

const mapStateToProps = function(store) {
  return {
    logs: store.logsKeyCreationReducer.logs || [],
    getLogsError: store.logsKeyCreationReducer.getLogsError,
    totalPages: store.logsKeyCreationReducer.totalPages,
    totalElements: store.logsKeyCreationReducer.totalElements,
  };
};

export default connect(mapStateToProps)(LogsKeyCreationListContainer);
